import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { formatPhoneNumber } from 'lib/utils/formManipulators'

import { Field } from 'formik'
import Input from './Input'
import { ExtendedFormikContext, Manipulator } from 'components/Forms/ExtendedFormik'

const PhoneNumberField = ({
    name,
    ...rest
}) => {
    const { setFieldValue, extendedActions, handleBlur } = useContext(ExtendedFormikContext)
    const { t } = useTranslation('formElements')

    return (
        <Field name={name}>
            {(props) => (
                <Input
                    {...props}
                    type="tel"
                    label={t('formElements:phoneNumber.label')}
                    onBlur={extendedActions.manipulateField(setFieldValue, name, [
                        Manipulator.create(formatPhoneNumber)
                    ], handleBlur)}
                    {...rest}
                />
            )}
        </Field>
    )
}

PhoneNumberField.propTypes = {
    name: PropTypes.string.isRequired,
}

export default PhoneNumberField
